export default {
  create: {
    title: 'Agregar',
    subtitle: 'Juegos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Juego',
    button: {
      add: 'Nuevo juego',
    },
  },
  list: {
    title: 'Shape Links',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  card: {
    title: 'Shape Link',
    actions: 'Acciones',
  },
  table: {
    title: 'Juegos activos',
    searchPlaceholder: 'Buscar por algo...',
  },
  form: {
    name: {
      label: 'Nombre:',
      placeholder: 'Ej: Shape Link Nivel 1',
      invalid: 'El nombre es obligatorio',
    },
    showAnswer: {
      label: 'Mostrar respuesta',
    },
    colored: {
      label: 'Colorido',
    },
    columns: {
      label: 'Columnas:',
    },
    rows: {
      label: 'Filas:',
    },
    numPairs: {
      label: 'Cantidad de pares:',
      auto: 'Automático',
      tooltipAuto: 'Sugerencia ideal: {count} pares para esta cuadrícula.',
      tooltipManual: 'Defina la cantidad de pares manualmente.',
    },
    filled: {
      label: 'Estilo del relleno:',
      auto: 'Automático',
      filled: 'Sólido',
      outline: 'Contorno',
      tooltipWarning: "Más de 9 pares: Relleno fijado en 'Automático'",
      tooltipInfo:
        'En el modo Automático, el sistema alterna entre sólido y contorno para mejor legibilidad',
    },
    shapeMode: {
      label: 'Modo de representación:',
      geometric: 'Formas geométricas',
      number: 'Números',
    },
    pathWeight: {
      label: 'Grosor de las líneas:',
      thin: 'Fina',
      normal: 'Normal',
      bold: 'Gruesa',
    },
    numberStyle: {
      label: 'Marco del número:',
      plain: 'Solo número',
      circle: 'Círculo',
      square: 'Cuadrado',
      rounded: 'Redondeado',
    },
  },
  button: {
    generate: 'Generar juego',
  },
  sidebar: {
    exportHint: 'Debe guardar antes de exportar.',
    defaultFileName: 'shapelinks',
  },
  alert: {
    generated: '¡Puzzle generado con éxito!',
    generateFailed: 'Error al generar el puzzle. Intente aumentar los pares.',
    generateError: 'Error en la generación.',
    workerError: 'Error interno en los workers.',
    gameSaved: '¡Juego guardado con éxito!',
    workerErrors: {
      seedProductionFailed: 'Error al producir semillas.',
      generationTimeout: 'No fue posible generar en el tiempo límite.',
    },
  },
};
